// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "3b070f3f5660a62afabb1c5c4ce99ef9" + ".css";
};